import { get } from 'vio-libs';
export function getLocation(locationSlug, consumerAPI = false) {
    if (!consumerAPI) {
        return get(`locations?location=${locationSlug}`);
    }
    return get(`v1/edge-locations/${locationSlug}`, undefined, true);
}
